import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/** Small shared building blocks (used by the web app and the admin panel). */
import { ExternalLink as ExternalIcon } from "lucide-react";
import { cn } from "./cn.js";
import { Input } from "./Field.js";
const GLYPHS = {
    ETH: "Ξ",
    BTC: "₿",
    USDT: "₮",
    USDC: "$",
    BNB: "B",
    TRX: "T",
    SOL: "◎",
};
/** Coin icon: a dark disc with the coin's symbol glyph (D49). */
export function AssetIcon({ symbol, className }) {
    return (_jsx("span", { "aria-hidden": true, className: cn("inline-flex size-12 shrink-0 items-center justify-center rounded-full bg-[#2A2932] text-xl font-semibold text-white", className), children: GLYPHS[symbol] ?? symbol.slice(0, 1) }));
}
/** Explorer links open in a new tab without giving the explorer access to this page. */
export function ExternalLink({ href, children, className, }) {
    return (_jsxs("a", { href: href, target: "_blank", rel: "noopener noreferrer", className: cn("inline-flex items-center gap-1 text-sm text-primary-strong hover:underline", className), children: [children, _jsx(ExternalIcon, { className: "size-3.5", "aria-hidden": true })] }));
}
/** 6-digit authenticator code input (works with phone "one-time code" autofill). */
export function CodeInput(props) {
    const { value, onChange, ...rest } = props;
    return (_jsx(Input, { ...rest, value: value, onChange: (e) => onChange(e.target.value.replace(/\D/g, "").slice(0, 6)), inputMode: "numeric", autoComplete: "one-time-code", pattern: "\\d{6}", maxLength: 6, placeholder: "123456", className: "font-mono text-lg tracking-[0.4em]" }));
}
/** Label/value row used in summaries. */
export function Row({ label, children, strong }) {
    return (_jsxs("div", { className: "flex items-start justify-between gap-4 py-1.5 text-sm", children: [_jsx("span", { className: "shrink-0 text-muted", children: label }), _jsx("span", { className: cn("min-w-0 text-right break-words text-fg", strong && "font-semibold"), children: children })] }));
}
/** Amount in monospace with its symbol. */
export function Amount({ value, symbol, className }) {
    return (_jsxs("span", { className: cn("font-mono tabular-nums", className), children: [value, " ", _jsx("span", { className: "text-muted", children: symbol })] }));
}
export function FullScreenSpinner() {
    return (_jsx("div", { className: "flex min-h-dvh items-center justify-center text-muted", children: _jsx("span", { className: "inline-block size-6 animate-spin rounded-full border-2 border-current border-t-transparent", role: "status", "aria-label": "Loading" }) }));
}
//# sourceMappingURL=bits.js.map